// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1Aj2d","cell":"ColumnAccessor_cell__3-aoM","firstCellAccent":"ColumnAccessor_firstCellAccent__3d-9a"};